import { Dialog, styled } from '@mui/material';

export type StyledDialogSize = 'default' | 'extraWide' | 'wide';

const dialogWidths: Record<Exclude<StyledDialogSize, 'default'>, number> = {
  wide: 960,
  extraWide: 1200,
};

const StyledDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'dialogSize',
})<{ dialogSize?: StyledDialogSize }>(({ dialogSize = 'default', theme }) => {
  const width = dialogSize === 'default' ? undefined : dialogWidths[dialogSize];

  return {
    '& .MuiDialog-paper': {
      ...(width && {
        width: `min(${width}px, calc(100vw - ${theme.spacing(8)}))`,
        maxWidth: width,
      }),
      padding: theme.spacing(3),
      borderRadius: theme.spacing(4),
      minWidth: 416,
      ...(!width && { maxWidth: 700 }),
      [theme.breakpoints.down('sm')]: {
        minWidth: '100%',
        padding: `${theme.spacing(1)} ${theme.spacing(0)}`,
        borderRadius: theme.spacing(2),
      },
    },
    '& .MuiDialogActions-root': {
      paddingRight: theme.spacing(2),
    },
    // Workaround for https://github.com/mui/material-ui/issues/29892
    '& .MuiDialogContent-root': {
      paddingTop: `${theme.spacing(1)} !important`,
      padding: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
      },
    },
  };
});

export default StyledDialog;
